export default __webpack_public_path__ + "static/media/cooperacao-alema.6091f026.png";